.inputContainer {
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .inputStyles {
    background-color: transparent;
    border: none;
    outline: none;
    font-weight: 500;
  }

  .textInput {
    width: 100%;
    box-sizing: border-box;
    padding-left: 12px;
    padding-right: 42px;
  }

  .noBorder {
    border: none;
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 12px;
    cursor: pointer;
    font-size: 20px;

    &.iconClickable {
      cursor: pointer;
      pointer-events: auto;
    }
  }

  .withIcon {
    padding-left: 44px;
  }

  .clearIcon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 24px;
    height: 18px;
    cursor: pointer;
    display: none;

    &.active {
      display: flex;
      align-items: center;
    }
  }

  .rotate {
    transform: rotate(180deg);
  }

  .iconContainer {
    display: flex;
    column-gap: 6px;
    align-items: center;

    div {
      display: flex;
      box-sizing: border-box;
    }
  }

  .singleValue > div > div {
    display: flex;
    column-gap: 6px;
    align-items: center;

    > div {
      height: 100%;
      display: flex;
    }
  }

  .multipicklist {
    height: fit-content;
  }
}

.singleValue {
  display: flex;
  align-items: center;
  column-gap: 6px;
  line-height: initial;
}

.inputContainerStyles,
.indicator,
.control {
  cursor: pointer;
}

.menu {
  z-index: 30 !important;
  .createLabel {
    display: flex;
    justify-content: start;
    align-items: center;
    column-gap: 6px;
  }

  .optionContainer {
    border-right: unset;
    border-left: unset;
    border-bottom: unset;
    &.newOption {
      padding-top: 12px;
      margin-top: 12px;
    }
    &:first-child {
      &.newOption {
        padding-top: 6px;
        margin-top: unset;
        border-top: unset;
      }
    }
    &.disabled {
      opacity: 0.3;
      cursor: default;
      user-select: none;
      pointer-events: none;
    }
  }
}

.option {
  border-radius: 12px;
  cursor: pointer;
  padding: 6px 12px;
  height: 34px;
  transition: background-color 0.25s ease-out;
  display: flex !important;
  align-items: center !important;
  column-gap: 12px;
  line-height: initial;
  height: fit-content;

  :hover {
    transition: background-color 0.25s ease-in;
  }
  &:not(:last-child) {
    margin-bottom: 9px;
  }

  .iconContainer {
    display: flex;
    column-gap: 6px;

    div {
      display: flex;
      box-sizing: border-box;
      align-items: center;
    }
  }

  &.focusedOption {
    @include themify($themes) {
      background-color: themed("neutral-tertiary");
    }
  }

  &.selectedOption {
    @include themify($themes) {
      background-color: themed("neutral-secondary");
    }
  }
}

.formattedLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
}

.multiValueContainerWrapper {
  max-width: 100%;
  min-width: 0;
  flex: 0 1 auto;

  > div {
    position: relative;
    padding-right: 20px;

    > .multiValueRemoveWrapper {
      position: absolute;
      right: 0;
      height: 100%;
      top: 0;
    }

    @include themify($themes) {
      background-color: themed("neutral-tertiary");
      .formattedLabel {
        color: themed("main-primary");
      }
    }
  }
}

.multiValueRemoveWrapper {
  flex-shrink: 0;
}

.multiValueRemoveWrapper > div {
  height: 100%;
  transition: background-color ease-out 0.25s;
  cursor: pointer;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 0 3px;
  &:hover {
    transition: background-color ease-in 0.25s;
    @include themify($themes) {
      background-color: themed("neutral-secondary");
      color: themed("main-primary");
      @include dark-mode() {
        background-color: themed("neutral-primary");
      }
    }
  }
}

.messageContainer {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  height: 34px;

  &.messageContainerCustom {
    height: 50px;
  }
}

.menuBottomText {
  padding-top: 6px;
  margin-top: 6px;
  @include themify($themes) {
    border-top: solid 1px themed("neutral-secondary");
  }
}

.bottomOption {
  padding-top: 6px;
  margin-top: 6px;
  @include themify($themes) {
    border-top: solid 1px themed("neutral-secondary");
  }
}
